import { GET_BALANCE_UNREAD_MESSAGE, GET_USERNAME } from "../mutation-types";
import { numberSpliter } from "@/utils/functions";
export default {
  [GET_BALANCE_UNREAD_MESSAGE]: state => {
    return {
      balance: numberSpliter(state.balance),
      numOfUnReadMessage: state.numOfUnReadMessage
    };
  },
  [GET_USERNAME]: state => {
    return state.title;
  }
};
